import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as styles from './styles.css';

import { ITextCell } from '../../../../../../types/newbuildingsCompare';

export interface ITextCellProps {
  cell: ITextCell;
}

export const TextCell = ({ cell }: ITextCellProps): React.JSX.Element => {
  if (cell.data?.text) {
    return (
      <div className={styles['container']}>
        <Body1>{cell.data.text}</Body1>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
    </div>
  );
};
